import {
  CheckCircleOutlined,
  EditOffOutlined,
  EditOutlined,
  FormatListBulletedOutlined
} from '@mui/icons-material';

export const documents = [
  {
    name: 'History & Physical (H&P)',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Unsigned',
    status: 'unsigned'
  },
  {
    name: 'Cardiology Report',
    category: 'EKG',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Pulmonary Function Test Report',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Radiology Reports (X-ray, CT, MRI, Ultrasound)',
    category: 'Laboratory',
    date: '06/09/2026',
    signature: 'Unsigned',
    status: 'unsigned'
  },
  {
    name: 'History & Physical (H&P)',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Progress Notes',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Unsigned',
    status: 'unsigned'
  },
  {
    name: 'Patient Registration Form',
    category: 'Consultation',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Consultation Notes',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Radiology Reports (X-ray, CT, MRI, Ultrasound)',
    category: 'Laboratory',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Progress Notes',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Signed',
    status: 'signed'
  },
  {
    name: 'Discharge Summary',
    category: 'Clinical',
    date: '06/09/2026',
    signature: 'Inactive',
    status: 'inactive'
  },
  {
    name: 'Consent for Treatment',
    category: 'Hospital',
    date: '06/09/2026',
    signature: 'Inactive',
    status: 'inactive'
  }
];

export const statusConfig = {
  all: {
    bg: '#F5F5F5',
    activeBg: '#BDBDBD',
    border: '#E0E0E0',
    activeBorder: '#9E9E9E',
    icon: <FormatListBulletedOutlined />
  },

  unsigned: {
    bg: '#FFF1F3',
    activeBg: '#FFDDE2',
    border: '#FFD5DB',
    activeBorder: '#FF8A8A',
    icon: <EditOffOutlined />
  },

  signed: {
    bg: '#EEF8EE',
    activeBg: '#DDF1DF',
    border: '#D3E8D6',
    activeBorder: '#8BC48F',
    icon: <EditOutlined />
  },

  inactive: {
    bg: '#EEE4F7',
    activeBg: '#DFD0F1',
    border: '#D8C5EC',
    activeBorder: '#A77FD3',
    icon: <CheckCircleOutlined />
  }
};

export const statusFilters = [
  { key: 'all', label: 'All' },
  { key: 'unsigned', label: 'Unsigned' },
  { key: 'signed', label: 'Signed' },
  { key: 'inactive', label: 'Inactive' }
];

export const categoryOptions = [
  { value: 'all', label: 'All Categories' },
  { value: 'clinical', label: 'Clinical' },
  { value: 'hospital', label: 'Hospital' },
  { value: 'laboratory', label: 'Laboratory' },
  { value: 'radiology', label: 'Radiology' }
];

export const dateRangeOptions = [
  { value: 'since inception', label: 'Since inception' },
  { value: '24', label: 'Last 24 months' },
  { value: '18', label: 'Last 18 months' },
  { value: '12', label: 'Last 12 months' },
  { value: '6', label: 'Last 6 months' },
  { value: '3', label: 'Last 3 months' }
];